import React from "react";
import ParticleField from "./ParticleField";
import { Kicker, SplitLines } from "./motion";
import { motion } from "framer-motion";

const MAP_BG = "https://static.prod-images.emergentagent.com/jobs/60fe7cfd-579c-48af-b4a9-bdfd3f1b809e/images/914819600daccdf0e6c8cf83f0f6de0f86a9c6712da306b52d3ca9786b152dcf.jpeg";

/* Shared inner-page hero: kicker, masked title, lead, optional aside. */
export default function PageHero({ kicker, title, lead, aside, testId }) {
  return (
    <section className="relative overflow-hidden border-b border-line" data-testid={testId}>
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70 mix-blend-multiply pointer-events-none"
        style={{ backgroundImage: `url(${MAP_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ivory/40 via-transparent to-ivory" />
      <ParticleField count={30} />
      <div className={`relative max-w-[1500px] mx-auto px-6 lg:px-12 pt-14 lg:pt-20 pb-16 lg:pb-24 grid grid-cols-1 ${aside ? "lg:grid-cols-12 gap-12" : ""}`}>
        <div className={aside ? "lg:col-span-7" : "max-w-4xl"}>
          <motion.div initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }}>
            <Kicker>{kicker}</Kicker>
          </motion.div>
          <h1 className="font-display text-5xl lg:text-7xl mt-6 leading-[1.02] text-ink">
            <SplitLines lines={[title]} delay={0.1} />
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.35 }}
            className="mt-7 text-lg lg:text-xl text-slate max-w-2xl leading-relaxed"
          >
            {lead}
          </motion.p>
        </div>
        {aside && (
          <motion.div
            initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.3 }}
            className="lg:col-span-5"
          >
            {aside}
          </motion.div>
        )}
      </div>
    </section>
  );
}
